import * as types from './mutation-types'

export default {
  [types.LOAD_QVCT_ANSWER_CHOICE](state, data) {
    state.AnswersChoise = data
  },

}
